<div
  class="header-container"
  [class.scrolled]="scrolled"
  [style.background-image]="'url(' + imageUrl + ')'"
>
  <app-header-actions
    [showFavorite]="true"
    [showShare]="true"
    [showTitle]="scrolled"
    [isFavorite]="true"
    title="Kafta Bovina"
    (favorite)="toggleFavorite()"
  ></app-header-actions>
</div>
